// Auto-generated file
export default {
  'atomic-ipx-button': async () => await import('./atomic-ipx-button/atomic-ipx-button.js'),
  'atomic-ipx-embedded': async () => await import('./atomic-ipx-embedded/atomic-ipx-embedded.js'),
  'atomic-ipx-modal': async () => await import('./atomic-ipx-modal/atomic-ipx-modal.js'),
  'atomic-ipx-recs-list': async () => await import('./atomic-ipx-recs-list/atomic-ipx-recs-list.js'),
  'atomic-ipx-refine-modal': async () => await import('./atomic-ipx-refine-modal/atomic-ipx-refine-modal.js'),
  'atomic-ipx-refine-toggle': async () => await import('./atomic-ipx-refine-toggle/atomic-ipx-refine-toggle.js'),
  'atomic-ipx-result-link': async () => await import('./atomic-ipx-result-link/atomic-ipx-result-link.js'),
  'atomic-ipx-tab': async () => await import('./atomic-ipx-tab/atomic-ipx-tab.js'),
  'atomic-ipx-tabs': async () => await import('./atomic-ipx-tabs/atomic-ipx-tabs.js'),
} as Record<string, () => Promise<unknown>>;

export type * from './index.js';